module.exports = __webpack_public_path__ + "static/media/Stare_hory_Uvaly.e593aac9.md";